import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import { useExpandableCard } from '../ExpandableCard';
import styles from './ExpandableCardHeader.module.scss';

type ExpandableCardHeaderProps = React.ComponentProps<'button'> & {
    expandIcon?: React.ReactNode;
    hideExpandIcon?: boolean;
};

export const ExpandableCardHeader: React.FC<ExpandableCardHeaderProps> = ({
    children,
    className,
    expandIcon,
    hideExpandIcon = false,
    onClick,
    ...props
}) => {
    const { isExpanded, toggleExpanded } = useExpandableCard();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        toggleExpanded();
        onClick?.(event);
    };

    const defaultIcon = (
        <FontAwesomeIcon
            icon={isExpanded ? faAngleUp : faAngleDown}
            className={styles.expandIcon}
        />
    );

    return (
        <button
            type="button"
            className={clsx(styles.header, className)}
            onClick={handleClick}
            {...props}
        >
            <div className={styles.headerContent}>
                {children}
                {!hideExpandIcon && (expandIcon || defaultIcon)}
            </div>
        </button>
    );
};
